import { ComboBox, IComboBoxProps } from '@fluentui/react';

export interface IPComboBoxProps extends IComboBoxProps {}

export const IPComboBox = (props: IPComboBoxProps) => {
  return <ComboBox {...props} />;
};
